import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
let ExpensepaymentModel = (_dec = attr('number'), _dec2 = attr('number'), _dec3 = attr('number'), _dec4 = attr('string'), _dec5 = attr('boolean'), _dec6 = attr('number', {
  defaultValue: 0
}), _dec7 = belongsTo('payment', {
  inverse: null,
  async: false
}), _dec8 = hasMany('file', {
  inverse: null,
  async: true
}), _dec9 = attr('boolean', {
  defaultValue: false
}), _class = class ExpensepaymentModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "year", _descriptor, this);
    _initializerDefineProperty(this, "month", _descriptor2, this);
    _initializerDefineProperty(this, "total", _descriptor3, this);
    _initializerDefineProperty(this, "period_name", _descriptor4, this);
    _initializerDefineProperty(this, "paid", _descriptor5, this);
    _initializerDefineProperty(this, "total_files_number", _descriptor6, this);
    _initializerDefineProperty(this, "payment", _descriptor7, this);
    _initializerDefineProperty(this, "files", _descriptor8, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor9, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "year", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "month", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "total", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "period_name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "paid", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "total_files_number", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "payment", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "files", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ExpensepaymentModel as default };
//# sourceMappingURL=expensepayment.js.map
